import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=47bee36f&scoped=true&"
import script from "./navigation.vue?vue&type=script&lang=js&"
export * from "./navigation.vue?vue&type=script&lang=js&"
import style0 from "./navigation.vue?vue&type=style&index=0&id=47bee36f&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bee36f",
  null
  
)

export default component.exports